import { render, staticRenderFns } from "./TemporalLayer.vue?vue&type=template&id=c37fbb44&"
import script from "./TemporalLayer.vue?vue&type=script&lang=ts&"
export * from "./TemporalLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports